import { LocalStorage } from "quasar";

// Gating is stored per customer so a shared device does not leak one
// customer's "Don't ask again" onto another.
const STORAGE_KEY_PREFIX = "push-optin-prompt";

const getStorageKey = (customerId) =>
  `${STORAGE_KEY_PREFIX}-${customerId || "guest"}`;

// The prompt keeps appearing while texts, emails or push are off; the only thing
// that stops it for good is the customer tapping "Don't ask again".
export const canShowPushOptInPrompt = (customerId) =>
  LocalStorage.getItem(getStorageKey(customerId))?.dismissed !== true;

export const dismissPushOptInPrompt = (customerId) => {
  LocalStorage.set(getStorageKey(customerId), { dismissed: true });
};

// The flags the prompt asks the customer to turn on. "Turn On" passes the ones
// still off to the settings screen as ?highlight=can_text,can_email so those
// rows can be highlighted there.
export const OPT_IN_FLAGS = ["can_text", "can_email", "can_push_notification"];

export const getOptInHighlights = (query) =>
  String(query?.highlight || "")
    .split(",")
    .filter((flag) => OPT_IN_FLAGS.includes(flag));
